import { useEffect, useState } from "react";
import { Save } from "lucide-react";
import { toast } from "sonner";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { PageHeader, Field } from "../components/Shared";
import { api, formatApiError } from "../lib/api";
import { useAuth } from "../context/AuthContext";
import EInvoicingSettings from "../components/EInvoicingSettings";
import SmsSettings from "../components/SmsSettings";
import { hasFeature } from "../lib/labels";

const FIELDS = [
  ["name", "Raison sociale", "text"], ["siret", "SIRET", "text"], ["vat_number", "N° TVA intracommunautaire", "text"], ["email", "E-mail", "text"],
  ["phone", "Téléphone", "text"], ["address", "Adresse (rue)", "text"], ["postal_code", "Code postal", "text"], ["city", "Ville", "text"], ["fleet_size", "Taille de flotte", "text"],
  ["rate_m3", "Tarif de base (€ / m³)", "number"], ["rate_km", "Frais kilométriques (€ / km)", "number"],
  ["google_review_url", "Lien de votre fiche Google (avis clients)", "url"],
];

export default function SettingsPage() {
  const { user, setUser } = useAuth();
  const [form, setForm] = useState(null);
  useEffect(() => {
    api.get("/company").then((r) => setForm(r.data));
  }, []);

  const save = async () => {
    try {
      const payload = Object.fromEntries(FIELDS.map(([k, , t]) => [k, t === "number" ? Number(form[k]) : form[k]]));
      const { data } = await api.put("/company", payload);
      setForm(data);
      setUser({ ...user, company_name: data.name });
      toast.success("Paramètres enregistrés");
    } catch (e) {
      toast.error(formatApiError(e));
    }
  };

  if (!form) return null;
  return (
    <div className="fade-up max-w-3xl">
      <PageHeader overline="Entreprise" title="Paramètres" subtitle="Ces informations apparaissent sur vos devis et servent au calcul des prix." />
      <div className="grid gap-4 rounded-xl border border-slate-200 bg-white p-6 sm:grid-cols-2" data-testid="settings-form">
        {FIELDS.map(([k, label, type]) => (
          <Field key={k} label={label}>
            <Input data-testid={`settings-${k}-input`} type={type} step="0.01" min={type === "number" ? 0 : undefined} value={form[k] ?? ""} onChange={(e) => setForm({ ...form, [k]: e.target.value })} />
          </Field>
        ))}
        <div className="sm:col-span-2">
          <Button data-testid="settings-save-button" className="bg-[#0b2c6b] hover:bg-[#1559d6]" onClick={save}><Save className="mr-2 h-4 w-4" />Enregistrer</Button>
        </div>
      </div>
      <SmsSettings />
      {hasFeature(user, "einvoicing") ? <EInvoicingSettings /> : <p className="mt-6 rounded-xl border border-dashed border-slate-300 bg-white p-5 text-sm text-slate-500" data-testid="einvoicing-locked">Factur-X et Plateforme Agréée : disponibles à partir de la formule Pro.</p>}
    </div>
  );
}
